/*
 * @Descripttion: 
 * @Author: KevinYoung
 * @Date: 2020-09-27 10:05:42
 * @LastEditors: KevinYoung
 * @LastEditTime: 2020-09-27 10:36:26
 */
import React from "react";
import { v4 } from "uuid";
import { RtcCall, RtcSocket, LocalMedia } from "./rtcCall";
import { RtcLinkView } from "./rtcLinkView";
import { connectConfig } from "./config";
export default class RtcCallPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            links: [],
        };
        this.socket = new RtcSocket(
            connectConfig.singal_server, 
            v4(), 
            null, 
            {
                name: "Hello",
                type: "web"
            });
        this.media = new LocalMedia();
        this.call = new RtcCall(
            connectConfig.turn_server,
            this.socket, 
            this.media
        );
        this.call.on("query", (query, info) => {
            query.video = true;
            query.audio = true;
        });
        this.call.on("call", link => {
            link.registerDataChannel("data");
            // link.on("datachannel", channel => {
                //可以做心跳检测，断连需要重新连接

                //数据通道收到信息
                // channel.onmessage = msg => console.log("datachannel", msg);
                // var timer = setInterval(() => channel.send(Math.random().toString()), 1000);
                // //数据通道关闭
                // channel.onclose = () => {
                //     clearInterval(timer);
                //     console.error("data channel closed");
                // };
            // })
            this.setState({
                link,
            });
            link.on("closed", () => this.setState({ link: null }));
        })
        this.media.video.on("enabled", enabled => {
            this.setState({ video: enabled });
        });
    }
    socket;
    call;
    media;
    async componentDidMount() {
        window.addEventListener("resize", this._resizeWindow);
        this.socket.connect();
        this.call.join(connectConfig.roomName, true);
        //this.call.join(window.location.pathname.replace('/','') || connectConfig.roomName, true);
        // window.onunload = () => {
        //     console.log('refresh')
        //     alert("refresh")
        //     this.call.close()
        //     this.socket.close()
        // }
    }
    _resizeWindow = () => {
        this.setState({ resize: new Date().getTime() })
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this._resizeWindow);
        this.call.close()
        this.socket.close()
    }
    render() {
        return (
            <div style={{width: '100vw', height:'100vh', backgroundColor: '#000'}}>
                {
                    this.state.link ?
                    <RtcLinkView link={this.state.link} />
                    :
                    null
                }
            </div>
        )
    }
}
